"use strict";

module.exports = function () {
  return Math.ceil(this.count / this.limit);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tables-2/compiled/computed/total-pages.js
// module id = 712
// module chunks = 0